var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-12" }, [
        _c("label", [_vm._v(_vm._s(_vm.label))])
      ]),
      _vm._v(" "),
      _vm._l(_vm.mappedOptions, function(option) {
        return _c("div", { key: option.id, staticClass: "col-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("label", { attrs: { for: option.id } }, [
                _vm._v(_vm._s(option.text))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                attrs: { id: option.id, type: "radio" },
                domProps: {
                  value: option.value,
                  checked: _vm._q(_vm.model, option.value)
                },
                on: {
                  change: function($event) {
                    _vm.model = option.value
                  }
                }
              })
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }